__turbopack_context__.v({
  "new_layout": "VRW4_q_new_layout",
  "policy_togglebtn_wrapper": "VRW4_q_policy_togglebtn_wrapper",
  "toggle_btn": "VRW4_q_toggle_btn",
});
